import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Referral() {
  const location = useLocation();

  useEffect(() => {
    const searchQueryParamForReferral = new URLSearchParams(
      location.search
    ).get("referral");
    if (searchQueryParamForReferral) {
      localStorage.setItem("referral", searchQueryParamForReferral);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return <div></div>;
}
